import FilterForm from 'components/forms/FilterForm';
import { Empty, Form, Input, Select, Table, Typography } from 'antd';
import { HttpError, useCan } from '@refinedev/core';
import { IClassroom } from 'interfaces/classrooms';
import { IGraduateDiscipline } from 'interfaces/graduate_disciplines';
import { SearchOutlined } from '@ant-design/icons';
import { TextField, useSelect, useTable } from '@refinedev/antd';
import { useParams } from 'react-router-dom';

interface IFilter {
  code: string;
  disciplineId: string;
}

const ClassroomList = () => {
  const { id } = useParams();
  const canListClassroomProfessors = useCan({
    resource: 'classroom_professors',
    action: 'list'
  });
  const canListGraduateDisciplines = useCan({
    resource: 'graduate_disciplines',
    action: 'list'
  });

  const { tableProps, searchFormProps } = useTable<
    IClassroom,
    HttpError,
    IFilter
  >({
    resource: `classrooms/professors`,
    queryOptions: {
      enabled: Boolean(canListClassroomProfessors.data?.can && id)
    },

    onSearch: ({ code, disciplineId }) => {
      return [
        {
          field: 'filter[by_classroom_code]',
          operator: 'eq',
          value: code
        },
        {
          field: 'filter[by_discipline_id]',
          operator: 'eq',
          value: disciplineId
        },
        {
          field: 'filter[by_professor_id]',
          operator: 'eq',
          value: id
        }
      ];
    },

    filters: {
      initial: [
        {
          field: 'filter[by_professor_id]',
          operator: 'eq',
          value: id
        }
      ]
    }
  });
  const { selectProps: disciplineSelectProps } = useSelect<IGraduateDiscipline>(
    {
      resource: 'graduate_disciplines',
      queryOptions: {
        enabled: Boolean(canListGraduateDisciplines.data?.can)
      },
      optionLabel: 'name',
      optionValue: 'id',

      onSearch: value => [
        {
          field: 'filter[name]',
          operator: 'eq',
          value
        }
      ],

      pagination: {
        mode: 'server',
        pageSize: 100
      }
    }
  );

  return (
    <>
      <Typography.Title level={5} style={{ margin: '24px 0' }}>
        Turmas
      </Typography.Title>

      <FilterForm searchFormProps={searchFormProps}>
        <Form.Item name="disciplineId" className="lg:col-span-6">
          <Select
            allowClear
            {...disciplineSelectProps}
            placeholder="Disciplina"
            notFoundContent={
              <Empty description="Nenhuma disciplina encontrada. Tente refazer sua busca com outros termos" />
            }
            suffixIcon={<SearchOutlined />}
          />
        </Form.Item>
        <Form.Item name="code" className="lg:col-span-3">
          <Input placeholder="Código da turma" />
        </Form.Item>
      </FilterForm>

      <Table {...tableProps} rowKey="id">
        <Table.Column<IClassroom>
          dataIndex={['classroom', 'discipline']}
          key="classroom"
          title="Disciplina"
          render={value => <TextField value={value.name} />}
        />
        <Table.Column
          dataIndex={['classroom', 'code']}
          key="code"
          title="Código da turma"
          render={value => <TextField value={value} />}
        />
      </Table>
    </>
  );
};

export default ClassroomList;
